/*
* Thème: PERFORMANCE
*/

/*
* Storytelling
*/

function setHeroContent(swiper, content, firstLoad) {
  let heroContent = swiper.$el.closest('.carousel__container').find('.carousel__content-wrapper .carousel__content');
  let heroContentWrapper = swiper.$el.closest('.carousel__container').find('.carousel__content-wrapper');

  if (firstLoad) {
    heroContent.html(content.html());
    adjustEqualHeight(swiper);
  } else {
    if (heroContent.length) {
      heroContentWrapper.addClass('--hidden');
      setTimeout(function() {
        heroContent.html(content.html());
        heroContentWrapper.removeClass('--hidden');
        adjustEqualHeight(swiper);
      }, 300);
    }
  }
}

function adjustEqualHeight(swiper) {
  const $container = swiper.$el.closest('.carousel__container');
  const $slide = swiper.$el.find('.swiper-slide-active');
  const $toolbar = $container.find('.carousel__toolbar');

  let paginationHeight = swiper.$el.find('.swiper-pagination').outerHeight();
  $toolbar[0].style.setProperty('--pagination-height', paginationHeight + 'px');

  $toolbar.css('min-height', '');
  $slide.css('min-height', '');

  const toolbarHeight = $toolbar.outerHeight(true);
  const slideHeight = $slide.outerHeight(true);
  const maxHeight = Math.max(toolbarHeight, slideHeight);

  $toolbar.css('min-height', maxHeight + 'px');
  $slide.css('min-height', maxHeight + 'px');
}

export default {
  speed: 550,
  rewind: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 0,
    }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      const slide = this.slides[index + 1];
      const title = $(slide).find('.card-storytelling__title').text().trim();
      return `<span class="${className}">${title}</span>`;
    }
  },
  on: {
    init: function(swiper) {
      if (swiper.$el.find('.carousel__content-wrapper').length == 0) {
        swiper.$el.find('.carousel__toolbar').prepend('<div class="carousel__content-wrapper"><div class="carousel__content"></div></div>');
      }

      swiper.$el.find('.swiper-pagination').attr('data-active-index', swiper.activeIndex);

      setTimeout(function() {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const slideContent = $(currentSlide).find('.card-storytelling__content');
        setHeroContent(swiper, slideContent, true);
      }, 650);

      adjustEqualHeight(swiper);
    },
    slideChangeTransitionStart: function(swiper) {
      swiper.$el.find('.swiper-pagination').attr('data-active-index', swiper.activeIndex);
      const currentSlide = swiper.slides[swiper.activeIndex];
      const slideContent = $(currentSlide).find('.card-storytelling__content');
      setHeroContent(swiper, slideContent, false);
    },
    resize: function(swiper) {
      adjustEqualHeight(swiper);
    },
  },
}

/* End: PERFORMANCE */
